export const environment = {
  production: true,
  version: '0.2.4',
  appName: 'delher-pwa',
  branchName: 'Juventino Rosas',  
  apiUrl: 'https://juv.api.delher.cloud',
  wsUrl: 'https://juv.api.delher.cloud',  
  timezone: 'America/Mexico_City',
  locale: 'en',
  assets: {
    DEFAULT_USER: 'assets/USER_DEFAULT.png',
    DEFAULT_USER_COLOR: 'assets/USER_COLOR.png',
    DEFAULT_VEHICLE: 'assets/VEHICLE_DEFAULT.png',
    DEFAULT_VEHICLE_COLOR: 'assets/VEHICLE_COLOR.png',
    DEFAULT_EXPENSE: 'assets/EXPENSE_DEFAULT.png',
    DEFAULT_EXPENSE_COLOR: 'assets/EXPENSE_COLOR.png',
    DEFAULT_SERVICE: 'assets/SERVICE_DEFAULT.png',
    DEFAULT_SERVICE_COLOR: 'assets/SERVICE_COLOR.png',
    DEFAULT_HISTORY: 'assets/HISTORY_DEFAULT.png',
    DEFAULT_HISTORY_COLOR: 'assets/HISTORY_COLOR.png',
    DEFAULT_CREDIT: 'assets/CREDIT_DEFAULT.png',
    DEFAULT_CREDIT_COLOR: 'assets/CREDIT_COLOR.png',
    DEFAULT_CUSTOMER: 'assets/CUSTOMER_DEFAULT.png',
    DEFAULT_CUSTOMER_COLOR: 'assets/CUSTOMER_COLOR.png'
  }
};   
